/*
 * organizations Reducer
 */
import get from 'lodash.get';
import keyBy from 'lodash.keyby';

import { RESET_STATE } from '../auth/constants';

import { ORGANIZATIONS_LOAD_SUCCEEDED } from './constants';
import { SCAFFOLD_DATA_LOAD_SUCCEEDED } from '../scaffoldData/constants';
import { OrganizationsActions } from './types';

const initialState = {};

function organizationsReducer(
    state = initialState,
    action: OrganizationsActions
) {
    switch (action.type) {
        case SCAFFOLD_DATA_LOAD_SUCCEEDED: {
            /*
                Loads the current organisation into the state to fix undefined organization.
                Organization state was undefined until they load Organizations route.
            */
            const organizations = get(action, 'response.organizations', {});

            if (!organizations) return state;
            return keyBy(organizations, 'id');
        }
        case ORGANIZATIONS_LOAD_SUCCEEDED: {
            const organizations = get(
                action,
                'payload.entities.organizations',
                {}
            );
            if (!organizations) return state;
            return organizations;
        }
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}

export default organizationsReducer;
